import React from 'react';
import type OptimizeWorkTypeSchemePageType from '@atlassian/jira-optimize-work-type-scheme-page/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyOptimizeWorkTypeSchemePagePage = lazyForPaint<
	typeof OptimizeWorkTypeSchemePageType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-jira-admin-pages-optimize-work-type-scheme-page", jiraSpaEntry: "async-jira-admin-pages-optimize-work-type-scheme-page" */ '@atlassian/jira-optimize-work-type-scheme-page'
			),
		),
	{ ssr: false },
);

export const OptimizeWorkTypeSchemePage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyOptimizeWorkTypeSchemePagePage}
		pageId="jira-admin-pages-optimize-work-type-scheme-page"
		shouldShowSpinner
	/>
);
